/**
 * Naming here is to match graphql-codegen enum
 */
export enum UserIdentifierType {
  Email = 'EMAIL',
  Phone = 'PHONE'
}